module.exports = __webpack_public_path__ + "img/training.61d02713.svg";